import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Car, Wallet, Menu, Grid2X2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { Sidebar } from './Sidebar'

const mainItems = [
  { icon: LayoutDashboard, label: 'Início', path: '/dashboard' },
  { icon: Grid2X2, label: 'Mapa', path: '/map' },
  { icon: Car, label: 'Saída', path: '/checkout' },
  { icon: Wallet, label: 'Caixa', path: '/cashier' },
]

export function MobileNav({ className }: { className?: string }) {
  const location = useLocation()

  return (
    <div
      className={cn(
        'flex items-center justify-around p-2 pb-safe border-t bg-card text-muted-foreground shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50',
        className,
      )}
    >
      {mainItems.map((item) => {
        const isActive = location.pathname === item.path
        return (
          <Link
            key={item.path}
            to={item.path}
            data-tour={`tour-nav-${item.path.slice(1)}`}
            className={cn(
              'flex flex-col items-center justify-center w-full py-2 space-y-1 rounded-lg transition-colors',
              isActive ? 'text-primary' : 'hover:text-foreground',
            )}
          >
            <item.icon
              className={cn('h-6 w-6', isActive && 'fill-primary/20')}
            />
            <span className="text-[10px] font-medium">{item.label}</span>
          </Link>
        )
      })}

      <Drawer>
        <DrawerTrigger asChild>
          <button className="flex flex-col items-center justify-center w-full py-2 space-y-1 rounded-lg text-muted-foreground hover:text-foreground transition-colors">
            <Menu className="h-6 w-6" />
            <span className="text-[10px] font-medium">Menu</span>
          </button>
        </DrawerTrigger>
        <DrawerContent className="h-[85vh]">
          <DrawerHeader className="border-b text-left">
            <DrawerTitle>Menu Principal</DrawerTitle>
          </DrawerHeader>
          <div className="flex-1 overflow-auto">
            <Sidebar className="border-none w-full" />
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  )
}
